import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, addDoc, deleteDoc, doc } from "firebase/firestore";
import './AdminDashboard.css';
import { useNavigate } from 'react-router-dom';
const AdminQuestPage = () => {
  const [quests, setQuests] = useState([]);
  const navigate = useNavigate();
  const [newQuest, setNewQuest] = useState({
    title: "",
    description: "",
    goal: 1,
    imageUrl: ""
  });

  // Fetch all quests
  const loadQuests = async () => {
    const colRef = collection(db, 'quests');
    const snapshot = await getDocs(colRef);
    const docs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setQuests(docs);
  };

  useEffect(() => {
    loadQuests();
  }, []);

  // Add new quest
  const handleAddQuest = async () => {
    const { title, description, goal, imageUrl } = newQuest;
    if (!title || !description || goal < 1 || !imageUrl) {
      alert("Please fill all fields correctly.");
      return;
    }
    await addDoc(collection(db, 'quests'), {
      title,
      description,
      goal: Number(goal),
      imageUrl
    });
    setNewQuest({ title: "", description: "", goal: 1, imageUrl: "" });
    loadQuests();
  };

  // Delete quest
  const handleDeleteQuest = async (id) => {
    if (!window.confirm("Delete this quest?")) return;
    await deleteDoc(doc(db, 'quests', id));
    loadQuests();
  };

  return (
    <div className="admin-container">
      <h2>🗺️ Quest Management</h2>

      <div className="admin-section">
        <h3>Add New Quest</h3>
        <div className="form-grid">
          <div>
            <label>Title</label>
            <input
              value={newQuest.title}
              onChange={(e) => setNewQuest({ ...newQuest, title: e.target.value })}
            />
          </div>
          <div>
            <label>Description</label>
            <input
              value={newQuest.description}
              onChange={(e) => setNewQuest({ ...newQuest, description: e.target.value })}
            />
          </div>
          <div>
            <label>Goal</label>
            <input
              type="number"
              min="1"
              value={newQuest.goal}
              onChange={(e) => setNewQuest({ ...newQuest, goal: Number(e.target.value) })}
            />
          </div>
          <div>
            <label>Image URL</label>
            <input
              value={newQuest.imageUrl}
              onChange={(e) => setNewQuest({ ...newQuest, imageUrl: e.target.value })}
            />
          </div>
          <button onClick={handleAddQuest}>Add Quest</button>
        </div>
      </div>

      <div className="admin-section">
        <h3>Existing Quests</h3>
        <table>
          <thead>
            <tr>
              <th>Image</th>
              <th>Title</th>
              <th>Description</th>
              <th>Goal</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {quests.map(q => (
              <tr key={q.id}>
                <td>
                  {q.imageUrl && (
                    <img src={q.imageUrl} alt={q.title} style={{ width: "64px", height: "64px", objectFit: "cover" }} />
                  )}
                </td>
                <td>{q.title}</td>
                <td>{q.description}</td>
                <td>{q.goal}</td>
                <td>
                  <button onClick={() => handleDeleteQuest(q.id)}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="tournament-actions" style={{ marginTop: '20px' }}>
        <button onClick={() => navigate('/admin-panelx-952504')}>⬅️ Back to Dashboard</button>
      </div>
    </div>
  );
};

export default AdminQuestPage;
